import React from 'react';
import { Alert } from 'react-bootstrap';
import { InputErrors as InputErrorsType } from '../../common/types/errors.types';

interface InputErrorsDisplayProps {
  inputErrors: InputErrorsType;
}

const InputErrorsDisplay: React.FC<InputErrorsDisplayProps> = ({
  inputErrors,
}) => {
  return (
    inputErrors &&
    Object.keys(inputErrors).map(key =>
      inputErrors[key].map(error => (
        <Alert variant="danger" key={`${key}-${error}`}>
          {error}
        </Alert>
      )),
    )
  );
};

export default InputErrorsDisplay;
